import { useState } from 'react';
import { useTheme } from 'styled-components';

import Hamberger from '~components/Icon/Hamberger';
import Search from '~components/Icon/Search';
import useHeaderStore from '~store/header';
import { getVisitedMypageToStorage, setVisitedMypageToStorage } from '~utils/browser/visitedMypage';

import ModalGnbMenu from '../ModalGnbMenu';
import ModalSearch from '../ModalSearch';
import ButtonLogin from './ButtonLogin';
import * as S from './style';

export default function HeaderContentsForMobile() {
  const theme = useTheme();
  const [visitedMypage, setVisitedMypage] = useState(getVisitedMypageToStorage());
  const { isModalGnbOpen, isModalSearchOpen, setIsModalGnbOpen, setIsModalSearchOpen } =
    useHeaderStore();

  const clearMypageVisited = () => {
    setVisitedMypageToStorage();
    setVisitedMypage(true);
  };

  return (
    <>
      <S.SearchWrapper>
        <S.FakeSearchBar
          onClick={() => setIsModalSearchOpen(true)}
          data-attribute-id='gnb'
          data-gnb-kind='search'>
          <S.IconWrapper>
            <Search width={17} height={17} color={theme.colors.magenta700} />
          </S.IconWrapper>
          기업을 검색해보세요.
        </S.FakeSearchBar>
      </S.SearchWrapper>
      <ButtonLogin isNew={!visitedMypage} onClick={clearMypageVisited} />
      <S.ButtonToggle onClick={() => setIsModalGnbOpen(true)}>
        <Hamberger />
      </S.ButtonToggle>

      {isModalGnbOpen && (
        <ModalGnbMenu
          isOpen={isModalGnbOpen}
          handleClose={(gnbId) => {
            setIsModalGnbOpen(false);

            if (gnbId === 'mypage') {
              clearMypageVisited();
            }
          }}
        />
      )}

      {isModalSearchOpen && (
        <ModalSearch isOpen={isModalSearchOpen} handleClose={() => setIsModalSearchOpen(false)} />
      )}
    </>
  );
}
